import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RegisterPasswordModal from '../components/RegisterPasswordModal';
import { 
  Wifi, 
  Shield, 
  Clock, 
  Users, 
  Globe, 
  Palette, 
  QrCode, 
  Printer,
  Server,
  FileEdit,
  Layout,
  Code,
  CheckCircle,
  ArrowRight,
  Zap,
  Check,
  X,
  ChevronLeft,
  ChevronRight
} from 'lucide-react';

/**
 * ========================================
 * 🔒 PROTECCIÓN DE REGISTRO HABILITADA
 * ========================================
 * Para DESHABILITAR la protección:
 * Cambiar la siguiente línea a: false
 */
const REGISTER_PASSWORD_ENABLED = false;
// ========================================

const LandingPage = () => {
  const navigate = useNavigate();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleRegisterClick = () => {
    if (REGISTER_PASSWORD_ENABLED) {
      setShowPasswordModal(true);
    } else {
      navigate('/register');
    }
  };

  const handlePasswordSuccess = () => {
    setShowPasswordModal(false);
    navigate('/register');
  };
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [currentPlanIndex, setCurrentPlanIndex] = useState(0);

  // Datos de los planes (mismos que en Step1SelectPlan)
  const plans = [
    {
      key: 'free',
      name: 'FREE',
      subtitle: '30 DÍAS GRATIS',
      badge: 'INCLUIDO',
      color: 'from-green-600 to-emerald-600',
      included: [
        'VPN',
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_vpn',
      name: 'SOLO VPN',
      color: 'from-blue-600 to-indigo-600',
      included: [
        'Acceso VPN'
      ],
      notIncluded: [
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_hotspot',
      name: 'SOLO HOTSPOT',
      color: 'from-blue-600 to-indigo-600',
      included: [
        'VPN',
        '1 Router',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        '3 Vendedores',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes'
      ],
      notIncluded: [
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'solo_pppoe',
      name: 'SOLO PPPOE',
      color: 'from-blue-600 to-indigo-600',
      included: [
        'VPN',
        '1 Router',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'hotspot_pppoe',
      name: 'HOTSPOT + PPPOE',
      color: 'from-blue-600 to-indigo-600',
      included: [
        'VPN',
        '1 Router',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        '3 Vendedores',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE'
      ],
      notIncluded: [
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ]
    },
    {
      key: 'todo_incluido',
      name: 'TODO INCLUIDO',
      badge: 'POPULAR',
      color: 'from-purple-600 to-pink-600',
      included: [
        'VPN',
        'Routers Ilimitados',
        'Planes Ilimitados',
        'Puntos de Venta Ilimitados',
        'Vendedores Ilimitados',
        'Impresion carta/ticket',
        'Cortes',
        'Reportes',
        'Gestion PPPoE',
        'Creador de Portales Cautivos',
        'Generador de Scripts',
        'Solucion MAC aleatoria'
      ],
      notIncluded: []
    }
  ];

  const nextPlan = () => {
    setCurrentPlanIndex((prev) => (prev + 1) % plans.length);
  };

  const prevPlan = () => {
    setCurrentPlanIndex((prev) => (prev - 1 + plans.length) % plans.length);
  };

  const screenshots = [
    {
      src: '/screenshot-dashboard.jpg',
      title: 'Dashboard Admin',
      description: 'Panel de control principal con estadísticas en tiempo real'
    },
    {
      src: '/screenshot-seller.jpg',
      title: 'Panel de Ventas',
      description: 'Genera fichas desde cualquier lugar del mundo'
    },
    {
      src: '/screenshot-pos.jpg',
      title: 'Puntos de Venta',
      description: 'Gestiona múltiples TPVs con precios diferentes'
    },
    {
      src: '/screenshot-sellers.jpg',
      title: 'Gestión de Vendedores',
      description: 'Control total de comisiones y saldos'
    }
  ];

  const features = [
    {
      icon: Shield,
      title: 'RouterOS V6 y V7',
      description: 'Compatible con todas las versiones de Mikrotik RouterOS',
      gradient: 'from-blue-500 to-cyan-500',
      bg: 'bg-blue-50'
    },
    {
      icon: Wifi,
      title: 'VPN Gratis Incluido',
      description: 'Conéctate a tu router desde cualquier lugar del mundo sin costo adicional',
      gradient: 'from-purple-500 to-pink-500',
      bg: 'bg-purple-50'
    },
    {
      icon: Shield,
      title: 'Conexión VPN Automática',
      description: 'Configuración de VPN completamente automatizada al registrarte',
      gradient: 'from-cyan-500 to-blue-500',
      bg: 'bg-cyan-50'
    },
    {
      icon: Clock,
      title: '30 Días Gratis',
      description: 'Prueba completa sin necesidad de tarjeta de crédito',
      gradient: 'from-green-500 to-emerald-500',
      bg: 'bg-green-50'
    },
    {
      icon: Users,
      title: 'Gestión de Vendedores',
      description: 'Sistema flexible: vendedores por saldo o por acumulativo',
      gradient: 'from-orange-500 to-red-500',
      bg: 'bg-orange-50'
    },
    {
      icon: Globe,
      title: 'Acceso Global',
      description: 'Genera fichas y reporta pagos desde cualquier parte del mundo',
      gradient: 'from-indigo-500 to-blue-500',
      bg: 'bg-indigo-50'
    },
    {
      icon: Palette,
      title: 'Diseño Intuitivo',
      description: 'Interfaz moderna y fácil de usar para todos tus vendedores',
      gradient: 'from-pink-500 to-rose-500',
      bg: 'bg-pink-50'
    },
    {
      icon: QrCode,
      title: 'Fichas con QR',
      description: 'Vouchers con código QR para fácil distribución',
      gradient: 'from-teal-500 to-cyan-500',
      bg: 'bg-teal-50'
    },
    {
      icon: Printer,
      title: 'Impresión Flexible',
      description: 'Compatible con miniprinters térmicas e impresoras normales',
      gradient: 'from-violet-500 to-purple-500',
      bg: 'bg-violet-50'
    }
  ];

  const comingSoon = [
    {
      icon: Server,
      title: 'Servidor PPPoE',
      description: 'Gestión completa de clientes PPPoE'
    },
    {
      icon: FileEdit,
      title: 'Diseñador de Fichas',
      description: 'Personaliza el diseño de tus vouchers'
    },
    {
      icon: Layout,
      title: 'Portales Cautivos',
      description: 'Crea y personaliza tus propios portales'
    },
    {
      icon: Code,
      title: 'Generador de Scripts',
      description: 'Hotspot, balanceo, failover y más'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/90 backdrop-blur-md border-b border-gray-200 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <Wifi className="w-8 h-8 text-blue-600" />
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                EasyTickets
              </span>
            </div>
            <button
              onClick={() => navigate('/login')}
              className="px-6 py-2 text-gray-700 hover:text-blue-600 font-semibold transition-colors"
            >
              Iniciar Sesión
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
            <Zap className="w-4 h-4" />
            Gestión de Hotspot Mikrotik en la Nube
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Administra tu Hotspot
            <br />
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Desde Cualquier Lugar
            </span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Sistema completo para gestionar vouchers de internet con Mikrotik. 
            Conexión VPN automática, múltiples vendedores y reportes en tiempo real.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={handleRegisterClick}
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-bold text-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
            >
              Probar Gratis
              <ArrowRight className="w-5 h-5" />
            </button>
            <button
              onClick={() => navigate('/login')}
              className="px-8 py-4 bg-white text-gray-700 rounded-lg font-semibold text-lg border-2 border-gray-300 hover:border-blue-600 hover:text-blue-600 transition-all"
            >
              Iniciar Sesión
            </button>
          </div>

          <p className="mt-6 text-sm text-gray-500">
            ✨ 30 días de prueba gratis • Sin tarjeta de crédito • Cancela cuando quieras
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Todo lo que Necesitas
            </h2>
            <p className="text-xl text-gray-600">
              Características diseñadas para facilitar tu negocio
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className={`p-6 rounded-xl ${feature.bg} border-2 border-white hover:border-opacity-0 hover:shadow-2xl transition-all transform hover:-translate-y-2`}
                >
                  <div className={`w-14 h-14 bg-gradient-to-br ${feature.gradient} rounded-xl flex items-center justify-center mb-4 shadow-lg`}>
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Coming Soon Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-indigo-100 via-purple-100 to-pink-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold mb-4">
              <Clock className="w-4 h-4" />
              Próximamente
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nuevas Funcionalidades
            </h2>
            <p className="text-xl text-gray-600">
              Estamos trabajando en estas increíbles características
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {comingSoon.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-white/80 backdrop-blur border-2 border-dashed border-purple-400 hover:border-purple-600 hover:bg-white transition-all transform hover:-translate-y-2 hover:shadow-xl"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center mb-4 opacity-75 shadow-lg">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-800 via-slate-900 to-gray-900">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Interfaz Moderna y Fácil de Usar
            </h2>
            <p className="text-xl text-gray-300">
              Diseño intuitivo para administradores y vendedores
            </p>
            <p className="text-sm text-gray-400 mt-2">
              Haz clic en cualquier imagen para ampliar
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {screenshots.map((screenshot, index) => (
              <div 
                key={index} 
                className="group cursor-pointer"
              >
                <div 
                  className="relative overflow-hidden rounded-xl shadow-2xl border-4 border-gray-700 transition-all hover:shadow-blue-500/50 hover:scale-105 hover:border-blue-500"
                  onClick={() => setSelectedImage(screenshot)}
                >
                  <img 
                    src={screenshot.src}
                    alt={screenshot.title}
                    className="w-full h-auto"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <div className="absolute bottom-4 left-4 right-4 text-white">
                      <h3 className="text-xl font-bold mb-1">{screenshot.title}</h3>
                      <p className="text-sm text-gray-200">{screenshot.description}</p>
                      <p className="text-xs text-blue-400 mt-2">Clic para ampliar →</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal de Zoom */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white hover:text-red-500 transition-colors z-50"
          >
            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div className="max-w-6xl w-full">
            <img 
              src={selectedImage.src}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="text-center mt-4 text-white">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-gray-300">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* Plans Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Planes y Precios
            </h2>
            <p className="text-lg text-gray-600">
              Elige el plan que mejor se adapte a tus necesidades
            </p>
          </div>

          {/* Mobile: Slider */}
          <div className="lg:hidden">
            <div className="relative">
              {/* Plan Card */}
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                {/* Header */}
                <div className={`p-6 text-center relative bg-gradient-to-br ${plans[currentPlanIndex].color}`}>
                  {plans[currentPlanIndex].badge && (
                    <div className={`absolute top-2 right-2 px-3 py-1 rounded-full text-xs font-bold ${
                      plans[currentPlanIndex].badge === 'POPULAR' 
                        ? 'bg-yellow-400 text-gray-900' 
                        : 'bg-green-400 text-gray-900'
                    }`}>
                      {plans[currentPlanIndex].badge}
                    </div>
                  )}
                  <h3 className="text-2xl font-extrabold text-white mb-2">
                    {plans[currentPlanIndex].name}
                  </h3>
                  {plans[currentPlanIndex].subtitle && (
                    <p className="text-sm text-white/90 font-medium">
                      {plans[currentPlanIndex].subtitle}
                    </p>
                  )}
                </div>

                {/* Features */}
                <div className="p-6 space-y-3 max-h-96 overflow-y-auto">
                  {plans[currentPlanIndex].included.map((item, index) => (
                    <div key={`inc-${index}`} className="flex items-center gap-2">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                      <span className="text-sm text-gray-700">{item}</span>
                    </div>
                  ))}
                  {plans[currentPlanIndex].notIncluded.map((item, index) => (
                    <div key={`exc-${index}`} className="flex items-center gap-2">
                      <X className="w-5 h-5 text-gray-400 flex-shrink-0" />
                      <span className="text-sm text-gray-400">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevPlan}
                className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors"
              >
                <ChevronLeft className="w-6 h-6 text-gray-700" />
              </button>
              <button
                onClick={nextPlan}
                className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-2 shadow-lg hover:bg-gray-50 transition-colors"
              >
                <ChevronRight className="w-6 h-6 text-gray-700" />
              </button>

              {/* Dots Indicator */}
              <div className="flex justify-center gap-2 mt-6">
                {plans.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentPlanIndex(index)}
                    className={`w-2 h-2 rounded-full transition-all ${
                      index === currentPlanIndex 
                        ? 'bg-blue-600 w-8' 
                        : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Desktop: Comparison Table */}
          <div className="hidden lg:block overflow-x-auto">
            <div className="inline-flex gap-4 min-w-full pb-4">
              {plans.map((plan, planIndex) => (
                <div
                  key={plan.key}
                  className="flex-shrink-0 w-64 bg-white rounded-2xl shadow-xl overflow-hidden"
                >
                  {/* Header */}
                  <div className={`p-6 text-center relative bg-gradient-to-br ${plan.color}`}>
                    {plan.badge && (
                      <div className={`absolute top-2 right-2 px-3 py-1 rounded-full text-xs font-bold ${
                        plan.badge === 'POPULAR' 
                          ? 'bg-yellow-400 text-gray-900 animate-pulse' 
                          : 'bg-green-400 text-gray-900'
                      }`}>
                        {plan.badge}
                      </div>
                    )}
                    <h3 className="text-xl font-extrabold text-white mb-2">
                      {plan.name}
                    </h3>
                    {plan.subtitle && (
                      <p className="text-xs text-white/90 font-medium">
                        {plan.subtitle}
                      </p>
                    )}
                  </div>

                  {/* Features */}
                  <div className="p-4 space-y-2 h-96 overflow-y-auto">
                    {plan.included.map((item, index) => (
                      <div key={`inc-${index}`} className="flex items-start gap-2">
                        <Check className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                        <span className="text-xs text-gray-700">{item}</span>
                      </div>
                    ))}
                    {plan.notIncluded.map((item, index) => (
                      <div key={`exc-${index}`} className="flex items-start gap-2">
                        <X className="w-4 h-4 text-gray-400 flex-shrink-0 mt-0.5" />
                        <span className="text-xs text-gray-400">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            ¿Listo para Empezar?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Comienza tu prueba gratuita hoy mismo. Sin compromisos, sin tarjeta de crédito.
          </p>
          <button
            onClick={() => navigate('/register')}
            className="px-10 py-4 bg-white text-blue-600 rounded-lg font-bold text-lg hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl inline-flex items-center gap-2"
          >
            Probar Gratis por 30 Días
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Wifi className="w-8 h-8 text-blue-400" />
                <span className="text-2xl font-bold text-white">EasyTickets</span>
              </div>
              <p className="text-gray-400">
                Gestión profesional de Hotspot Mikrotik en la nube
              </p>
            </div>
            
            <div>
              <h3 className="text-white font-bold mb-4">Producto</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-blue-400 transition-colors">Características</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Precios</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Documentación</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-bold mb-4">Soporte</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-blue-400 transition-colors">Centro de Ayuda</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Contacto</a></li>
                <li><a href="#" className="hover:text-blue-400 transition-colors">Estado del Sistema</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 text-center text-gray-500">
            <p>&copy; 2025 EasyTickets. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      {/* Modal de contraseña para registro */}
      <RegisterPasswordModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
        onSuccess={handlePasswordSuccess}
      />
    </div>
  );
};

export default LandingPage;
